import { render, staticRenderFns } from "./indexModelFour.vue?vue&type=template&id=0fccc1c5&scoped=true&"
import script from "./indexModelFour.vue?vue&type=script&lang=js&"
export * from "./indexModelFour.vue?vue&type=script&lang=js&"
import style0 from "./indexModelFour.vue?vue&type=style&index=0&id=0fccc1c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fccc1c5",
  null
  
)

export default component.exports